/**
 * Formatuje kod pocztowy w trakcie wpisywania: zostają tylko cyfry i myślnik,
 * po dwóch cyfrach automatycznie wstawiany jest myślnik (12-345).
 */
export function formatPostalCode(raw: string): string {
  let value = raw.replace(/[^\d-]/g, "");
  if (value.length > 2 && !value.includes("-")) {
    value = value.slice(0, 2) + "-" + value.slice(2);
  }
  return value;
}
